export default __webpack_public_path__ + "static/SRF Carasweet 5SG7806 - Fiche de spécifications et données techniques-6d7d3bc165c523928dc8adb4e2738756.pdf";